/*! Copyright (c) Safe As Milk. All rights reserved. */
class HeaderContainer extends HTMLElement {
    #boundOnScroll;
    #headerStickyObserver;
    #lastScrollTop = 0;
    #navbarHeight = 0;
    #scrollTicking = false;
    #sticky = false;
    constructor() {
        super();
        this.#boundOnScroll = this.#onScroll.bind(this);
    }
    connectedCallback() {
        this.#sticky = Boolean(this.dataset.sticky);
        if (!this.#sticky) return;
        this.#headerStickyObserver = new IntersectionObserver((([e]) => document.body.classList.toggle("header-stuck", !e.isIntersecting)), {
            threshold: [1]
        });
        this.#headerStickyObserver.observe(this);
        const header = this.querySelector(".js-header");
        if (header?.classList.contains("js-header-scroll")) {
            this.#navbarHeight = header.getBoundingClientRect().height + 50;
            document.body.classList.add("header-down");
            window.addEventListener("scroll", this.#boundOnScroll, { passive: true });
        }
    }
    disconnectedCallback() {
        if (!this.#sticky) return;
        this.#headerStickyObserver?.disconnect();
        window.removeEventListener("scroll", this.#boundOnScroll);
    }
    #onScroll() {
        if (this.#scrollTicking) return;
        this.#scrollTicking = true;
        requestAnimationFrame(() => {
            this.#updateScrollDirection();
            this.#scrollTicking = false;
        });
    }
    #updateScrollDirection(delta = 5) {
        const st = window.scrollY;
        if (Math.abs(this.#lastScrollTop - st) <= delta) return;
        if (st > this.#lastScrollTop && st > this.#navbarHeight) {
            document.body.classList.remove("header-down");
            document.body.classList.add("header-up");
        } else {
            document.body.classList.remove("header-up");
            document.body.classList.add("header-down");
        }
        this.#lastScrollTop = st <= 0 ? 0 : st;
    }
}

customElements.define("header-container", HeaderContainer);
//# sourceMappingURL=header-container.js.map
